export const residences_types = {
  villa: "خانه ویلایی",
  hotel: "هتل",
  apartment: "آپارتمان",
  "hotel-apartment": "هتل آپارتمان",
  suit: "سوئیت",
  boomgardi: "بوم گردی",
  motel: "مهمان خانه",
  cottage: "کلبه",
};
